import { ApiManager } from '../core/api-manager';

/**
 * Assegnazione di un utente al suo condominio (api/custom_classes/UtenteEngine.php).
 *
 * Non passa da DataManager perche' `idUserGroup` la CRUD del framework non lo
 * accetta ne' in creazione ne' in modifica: lo timbra da sola con il gruppo di
 * chi scrive. Per l'amministratore globale, che i condomini li ha tutti
 * davanti, quel timbro e' sempre Gruppo YEC — cioe' sempre sbagliato.
 */
async function assegnaUtente(idUser, idUserGroup) {
    let body = {
        idUser: idUser,
        idUserGroup: idUserGroup
    }
    let response = await ApiManager.sendAuthenticatedRequest('/custom/assegna_utente', body)
    return response;
}


/**
 * Credenziali di accesso per email (api/custom_classes/CredenzialiEngine.php):
 * a ogni destinatario si genera una password provvisoria nuova, che sostituisce
 * quella che aveva. `destinatari` e' { id } per un utente, oppure
 * { tutti: true, idUserGroup } per tutti i condomini abilitati, anche chi le ha gia' avute.
 */
async function inviaCredenziali(destinatari) {
    let response = await ApiManager.sendAuthenticatedRequest('/custom/invia_credenziali', destinatari)
    return response;
}


export const UtentiManager = {
    assegnaUtente: assegnaUtente,
    inviaCredenziali: inviaCredenziali
};
